export default __webpack_public_path__ + "static/hero-image-1-8340f91e40299b8df337dd316bdeb0a4.jpg";